module.exports = __webpack_public_path__ + "img/signature.ea9523a8.png";